<template>
  <div>
    <div class="GeZai_Layer relative">
      <img :src="frameImgs.img" class="h350" alt="" />

      <div class="button-img" :class="$store.getters.hOrV">
        <img :src="keyImgs.img" class="h350" alt="" />
      </div>

      <div class="body-img" :class="$store.getters.hOrV">
        <div
          class="table2"
        >
          <engraving-elements :elements="layer4" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EngravingElements from "../../../components/EngravingElements.vue";
var albaPositions = {
  icon: {
    medium: {
      P7: { x: 6.5, y: 6.5 },
    }
  },
  button: {
    single: {
      K2: [
        { x: 24.4, y: 43 },
        { x: 61.6, y: 43 },
      ],
      K4: [
        { x: 24.4, y: 26.2 },
        { x: 61.6, y: 26.2 },
        { x: 24.4, y: 59.8 },
        { x: 61.6, y: 59.8 },
      ],
      K6: [
        { x: 24.4, y: 17.8 },
        { x: 61.6, y: 17.8 },
        { x: 24.4, y: 43 },
        { x: 61.6, y: 43 },
        { x: 24.4, y: 68.2 },
        { x: 61.6, y: 68.2 },
      ],
      K8: [
        { x: 24.4, y: 17.8 },
        { x: 61.6, y: 17.8 },
        { x: 24.4, y: 34.6 },
        { x: 61.6, y: 34.6 },
        { x: 24.4, y: 51.4 },
        { x: 61.6, y: 51.4 },
        { x: 24.4, y: 68.2 },
        { x: 61.6, y: 68.2 },
      ],
      M1: [
        { x: 24.4, y: 51.4 },
        { x: 61.6, y: 51.4 },
        { x: 16.1, y: 68.2 },
        { x: 32.5, y: 68.2 },
        { x: 53.3, y: 68.2 },
        { x: 69.7, y: 68.2 },
      ]
    }
  },
  buttonSize: { height: 9, width: 9 },
  alignment: {
    iconOnly: {
      topcenter: { textL1: "", icon: "P7" },
    }
  },
};

import isBigIconMixin from "../../../mixins/isBigIconMixin";

export default {
  name: "BlackJackPanel",
  components: {
    EngravingElements,
  },
  mixins: [isBigIconMixin],
  data() {
    return {};
  },
  created() {
    this.styleMap = this.$store.state.styleMap;
  },
  computed: {
    frameImgs: function() {
      
      return { img: "images/collection/faces/m" + [this.$store.state.artwork.frameColor, this.$store.state.productCode.opt2[this.$store.state.artwork.format].toLowerCase()].join('_') + ".png" }
    },
    keyImgs: function() { this.$store.state.artwork.keyColor
      return { img: "images/collection/buttons/m" + [this.$store.state.artwork.frameColor, this.$store.state.artwork.layout.toLowerCase(), this.$store.state.artwork.buttonFormat].join('_') + ".png" }
    },
    layer4: function () {
      var alignment = {};
      if (
        typeof albaPositions.alignment[this.$store.state.artwork.layoutStyle] !=
        "undefined"
      ) {
        alignment =
          albaPositions.alignment[this.$store.state.artwork.layoutStyle][
            this.$store.state.artwork.alignment
          ];
      }
      var layoutList = [];

      for (
        var i = 0;
        i <
        albaPositions.button[this.$store.state.artwork.format][
          this.$store.state.artwork.layout
        ].length;
        i++
      ) {
        var lm =
          albaPositions.button[this.$store.state.artwork.format][
            this.$store.state.artwork.layout
          ][i];
        var iconSizeLabel =
          this.$store.state.iconSizeMap[
            this.isBigIcon(this.$store.state.artwork.content[i])
              ? this.$store.state.bigIconSize
              : this.$store.state.artwork.iconSize
          ];
          
        var o = {
          id: i,
          top: lm.y,
          left: lm.x,
          height:
            albaPositions.buttonSize.height,
          width:
            albaPositions.buttonSize.width,
          iconSize: this.isBigIcon(this.$store.state.artwork.content[i])
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.iconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(this.$store.state.artwork.content[i])
            ? albaPositions.icon[iconSizeLabel]["P7"]
            : albaPositions.icon[iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
                this.$store.state.artwork.layout
              ][this.$store.state.artwork.layoutStyle][i],
          },
          content: this.$store.state.artwork.content[i],
        };
        layoutList.push(o);
        this.$store.commit("setAlignment", {
          alignment: this.$store.state.artwork.alignment,
          index: i,
        });
      }

      return layoutList;
    }
  },
};
</script>
